import { fmtBrl } from '../shared/formatters'
import { summarizeRaw } from '../shared/periods'

export const buildGrossProfitRow = ({
  monthKeys,
  hybridAgg,
  cmvAgg,
  usePriceCostAsCMV = true,
  summaryPeriods,
}) => {
  const rawValues = monthKeys.map((_, i) => {
    const retailRevenue = hybridAgg[i]?._grossRevenue;
    if (retailRevenue == null) return null;

    if (usePriceCostAsCMV) {
      const cmvTotal = cmvAgg?.[i]?._cmvTotal;
      if (cmvTotal != null) return retailRevenue - cmvTotal;
    }

    const unitsSold = hybridAgg[i]?._unitsSold;
    const unitCost = hybridAgg[i]?._unitCost;

    if (unitsSold != null && unitCost != null) {
      return retailRevenue - unitsSold * unitCost;
    }

    const grossMargin = hybridAgg[i]?._grossMargin;
    return grossMargin != null ? retailRevenue * grossMargin : null;
  });

  const values = rawValues.map(v => v != null ? fmtBrl(v) : null);

  const semRawValues = summarizeRaw(rawValues, summaryPeriods);

  return {
    values,
    rawValues,
    semValues: semRawValues.map(v => v != null ? fmtBrl(v) : null),
    semRawValues,
  };
};